import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { FeedbackService } from 'src/app/api/contactus/feedback.service';
import { AuthenticationServiceImpl } from 'src/app/core/authentication/authentication-service-impl.service';

@Component({
  selector: 'app-feedback-dialog',
  templateUrl: './feedback-dialog.component.html',
  styleUrls: ['./feedback-dialog.component.scss'],
})
export class FeedbackDialogComponent {
  form: FormGroup;
  submitted = false;
  loading = false;
  error: string | null = null;

  private subscriptions: Subscription[] = [];

  constructor(
    private dialogRef: MatDialogRef<FeedbackDialogComponent>,
    private fb: FormBuilder,
    private feedbackService: FeedbackService,
    private authService: AuthenticationServiceImpl
  ) {
    this.form = this.fb.group({
      firstName: ['', [Validators.required, Validators.maxLength(50)]],
      lastName: ['', [Validators.required, Validators.maxLength(50)]],
      feedbackType: ['', Validators.required],
      message: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(1000)]],
    });
  }

  get firstName() {
    return this.form.get('firstName');
  }
  get lastName() {
    return this.form.get('lastName');
  }
  get feedbackType() {
    return this.form.get('feedbackType');
  }
  get message() {
    return this.form.get('message');
  }

  close(): void {
    this.dialogRef.close();
  }

  submit(): void {
    this.submitted = true;
    this.error = null;
    if (this.form.valid) {
      this.loading = true;
      const token = this.authService.getToken();
      const formValue = { ...this.form.value };
      // Prepend feedback type to the message
      let feedbackMessage = formValue.message;
      if (formValue.feedbackType && formValue.message) {
        const typeLabel = formValue.feedbackType.charAt(0).toUpperCase() + formValue.feedbackType.slice(1);
        feedbackMessage = `${typeLabel}: ${formValue.message}`;
      }
      const payload = {
        firstName: formValue.firstName,
        lastName: formValue.lastName,
        feedbackMessage,
      };
      const sub = this.feedbackService.submitFeedback(payload, token).subscribe({
        next: response => {
          this.loading = false;
          if (response.status === 200) {
            this.dialogRef.close({ success: true, data: response.body });
          } else {
            this.error = 'Unexpected response from server.';
          }
        },
        error: () => {
          this.loading = false;
          this.error = 'Failed to submit feedback. Please try again later.';
        },
      });
      this.subscriptions.push(sub);
    }
  }

  // called automatically when the dialog is destroyed
  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
}
